import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  itemType: {
    color: theme.palette.grey.black,
    fontSize: 14,
    fontWeight: theme.typography.fontWeightRegular,
    paddingLeft: theme.spacing(0.5)
  }
}));
